
import './main.css'

import { useEffect, useState } from 'react';
import {
  SaveOutlined, UserAddOutlined, RightOutlined, VideoCameraOutlined, ExclamationCircleOutlined, SettingOutlined, CrownOutlined, MessageOutlined, FireOutlined, CommentOutlined, LinkOutlined, YoutubeOutlined, PlusCircleOutlined, ReloadOutlined, ProfileOutlined, UserSwitchOutlined, CheckCircleFilled, CheckCircleTwoTone, DollarOutlined, ShopOutlined, DashOutlined, DashboardOutlined, BarChartOutlined, MailOutlined, GlobalOutlined, ArrowUpOutlined, UpOutlined, ShoppingCartOutlined,
  InstagramOutlined, FacebookFilled, FacebookOutlined, PhoneOutlined, SendOutlined, InfoCircleOutlined, CheckCircleOutlined, ThunderboltOutlined, SafetyCertificateFilled, ThunderboltFilled, OpenAIFilled, CalendarOutlined, MenuFoldOutlined,
  MenuUnfoldOutlined, HomeOutlined, LeftOutlined
} from '@ant-design/icons';
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Drawer, Layout, Spin, Timeline, Popover, Radio, Card, Progress, Button, Modal, Input, Space, message, Carousel, Tabs, Collapse, Tooltip, Divider, Slider, Select, Tag, Alert, Steps, Checkbox, Flex, Typography, Row, Col, Badge, Menu } from 'antd';
import logo from '../../images/logo.png'
import callAPI from '../fetch/main';
import ShowPlans from "../../comps/show_plans/main";
import confetti from 'canvas-confetti';
import { fireDB } from "../../funcs/firebase";

import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import LegendProOfferModal from './claimOneMonth';
import DraggableTutorial from './DraggableTutorial ';
import UserRoleManager from './UsersRoles';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import FirstAutomationOnboarding from './FirstAutomationOnboarding';
import OnboardingPricingModal from './OnboardingPricingModal';
import { trackCompletedSignup, trackSubscription } from '../../funcs/metaPixel';



const { Title, Text } = Typography;

const antSider = Layout.Sider;


const steps = [
  { title: "Saving the data", icon: <SaveOutlined /> },
  { title: "Creating account", icon: <UserAddOutlined /> },
  { title: "Adding demo automation to your reel/posts", icon: <ThunderboltOutlined /> },
  { title: "Adding Demo DM automation", icon: <MessageOutlined /> },
  { title: "Finalizing all the details", icon: <SettingOutlined /> },
  { title: "Account created", icon: <CheckCircleTwoTone twoToneColor="#52c41a" /> },
];

function AccountCreationSteps({ setCurrentAutomateStep, onComplete }) {

  const [current, setCurrent] = useState(0);
  const [running, setRunning] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!running) return;

    // Simulate a step loading for 2 seconds
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
      if (current < steps.length - 1) {
        setCurrent((prev) => prev + 1);
      } else {
        setRunning(false);
        confetti({
          particleCount: 400,
          spread: 150,
          origin: { y: 0.6 },
          zIndex: 9999,
        });
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [running, current]);

  const startProcess = () => {
    setRunning(true);
    setCurrent(0);
    setLoading(true);
  };

  const resetProcess = () => {
    setRunning(false);
    setCurrent(0);
    setLoading(false);
  };

  useEffect(() => {
    startProcess()
  }, [])

  const goToWelcomePage = () => {
    // Trigger pricing popup first, then navigate
    if (onComplete) {
      onComplete();
    } else {
      window.location.href = '/home';
    }
  };

  return (
    <Card
      style={{
        maxWidth: 500,
        margin: "0 auto",
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        height: "auto"
      }}
    >
      <Title level={4} style={{ marginBottom: 4 }}>
        {current === steps.length - 1
          ? "🎉 Account created successfully"
          : "Setting up your account"}
      </Title>
      <Text type="secondary">{steps[current]?.title || "Initializing..."}</Text>

      <Timeline
        mode="left"
        style={{ marginTop: 20, marginBottom: 20 }}
        items={steps.slice(0, current + 1).map((s, i) => ({
          dot: i === current && running ? <Spin size="small" /> : s.icon,
          color: i < current ? "green" : i === current ? "blue" : "gray",
          children: (
            <div
              key={i}
              className={`timeline-item ${i === current ? "active" : "completed"}`}
            >
              {s.title}
            </div>
          ),
        }))}
      />

      {
        current == (steps.length - 1) &&
        <Button type="primary" onClick={goToWelcomePage} block>
          Continue to InstantDM
        </Button>
      }
    </Card>
  );

}

function TestCommentAutomation({ setCurrentAutomateStep, link, image_url, username }) {

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisabled(false);
    }, 3000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f8f8f8",
        padding: "20px",
        flexWrap: "wrap"
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "800px",
          width: "100%",
          display: "flex",
          gap: "30px",
          flexWrap: "wrap"
        }}
      >
        {/* Left Image Placeholder */}
        <Badge.Ribbon text="Automated for quick start" placement={"start"}>
          <img
            src={image_url}
            style={{
              flex: "0 0 240px",
              // background: "#E0E0E0",
              borderRadius: "8px",
              height: "auto",
              maxHeight: "400px",
              width: "100%"
            }}
          />
        </Badge.Ribbon>

        {/* Right Content */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", width: "100%" }}>
          <Title level={3} style={{ marginBottom: 8, textAlign: "center" }}>
            👉 Let’s Test Your First Comment 2 DM Automation.
          </Title>
          <Text style={{ color: "#555", display: "block", marginBottom: 16, textAlign: "center" }}>
            We’ve set up a demo on your Instagram post so you can see how comment-to-DM works—instantly.
          </Text>

          <ol style={{ paddingLeft: "20px", lineHeight: 1.8 }}>
            <li>
              <a href={link} target='_blank' style={{ color: "blue" }}>Open this reel/post</a> in your{" "}
              <strong>personal instagram account.</strong>
            </li>
            <li>
              Comment <strong>“Link”</strong> or <strong>“Demo”</strong>.
            </li>
            <li>
              Boom, You have received couple of message from <strong>@{username}</strong>.
            </li>
          </ol>

          {/* <Text type="secondary" style={{ marginTop: 10 }}>
            Note: You will get 3 messages now and 2 messages after 5 minutes delay.
          </Text> */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "24px",
              flexWrap: "wrap",
              gap: "10px"
            }}
          >

            {/* <Button size="large" block>Watch Setup Video</Button> */}
            <Button onClick={() => { setCurrentAutomateStep(1) }} type="primary" size="large" block disabled={disabled}>
              It's Working
            </Button>
            <Button onClick={() => { setCurrentAutomateStep(1) }} size="large" block disabled={disabled}>
              Not Working
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}


function TestDMAutomation({ setCurrentAutomateStep, username, pp, name }) {

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisabled(false);
    }, 3000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f8f8f8",
        padding: "20px",
        flexWrap: "wrap"
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "800px",
          width: "100%",
          display: "flex",
          gap: "30px",
          flexWrap: "wrap"
        }}
      >
        {/* Left Image Placeholder */}


        <div
          style={{
            // flex: "0 0 320px",
            background: "#000",
            borderRadius: "12px",
            height: "500px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            maxWidth: "320px"
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 12px",
              borderBottom: "1px solid rgba(255,255,255,0.1)",
              background: "#000",
            }}
          >
            <Flex align="center" gap={10}>
              <img
                src={pp}
                alt="profile"
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <p
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontWeight: 500,
                  margin: 0,
                }}
              >
                {name}
              </p>
              <CheckCircleFilled style={{ color: "white" }} />
            </Flex>

            <Flex gap={16}>
              <PhoneOutlined style={{ color: "white", fontSize: "18px", cursor: "pointer" }} />
              <VideoCameraOutlined style={{ color: "white", fontSize: "18px", cursor: "pointer" }} />
            </Flex>
          </div>

          {/* Chat Body */}
          <div
            style={{
              flex: 1,
              padding: "16px",
              overflowY: "auto",
              background: "#000",
            }}
          >

            <div
              style={{
                background: "#3797F0",
                color: "white",
                padding: "8px 12px",
                borderRadius: "16px",
                maxWidth: "20%",
                alignSelf: "flex-end",
                marginLeft: "auto",
                width: "30px",
                marginBottom: "20px",

              }}
            >
              Price
            </div>

            <div
              style={{
                background: "#262626",
                color: "white",
                padding: "8px 12px",
                borderRadius: "16px",
                maxWidth: "70%",
                marginBottom: "10px",
              }}
            >
              👋 Hey there! This is a preview of your DM automation.
            </div>
            <div
              style={{
                background: "#262626",
                color: "white",
                padding: "8px 12px",
                borderRadius: "16px",
                maxWidth: "70%",
                marginBottom: "10px",
              }}
            >
              Go ahead, send a message "Price", and watch it in action.
            </div>
          </div>

          {/* Input Bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px 12px",
              borderTop: "1px solid rgba(255,255,255,0.1)",
              background: "#000",
            }}
          >
            <input
              type="text"
              placeholder="Message..."
              disabled
              style={{
                flex: 1,
                background: "#1A1A1A",
                border: "none",
                color: "#888",
                padding: "8px 12px",
                borderRadius: "20px",
                outline: "none",
                fontSize: "14px",
              }}
            />
            <SendOutlined
              style={{
                color: "#3797F0",
                fontSize: "20px",
                marginLeft: "10px",
              }}
            />
          </div>
        </div>


        {/* Right Content */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", width: "100%" }}>
          <Title level={3} style={{ marginBottom: 8, textAlign: "center" }}>
            👉 Test your first DM automation.
          </Title>
          <Text style={{ color: "#555", display: "block", marginBottom: 16, textAlign: "center" }}>
            We just automate your DM to send automated reply.
          </Text>

          <ol style={{ paddingLeft: "20px", lineHeight: 1.8 }}>
            <li>
              Message @{username} <strong>“Price”</strong> or <strong>“course”</strong> from {" "}
              <strong>your personal instagram account</strong>
            </li>
            <li>
              Boom, You have received couple of messages from @{username}
            </li>
          </ol>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "24px",
              flexWrap: "wrap",
              gap: "10px"
            }}
          >

            {/* <Button size="large" block>Watch Setup Video</Button> */}
            <Button onClick={() => { setCurrentAutomateStep(2) }} type="primary" size="large" block disabled={disabled}>
              It's Working
            </Button>
            <Button onClick={() => { setCurrentAutomateStep(2) }} size="large" block disabled={disabled}>
              Not Working
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}


function ConnectFBUI() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f5f6f8",
        padding: "20px",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: 16,
          padding: "32px 24px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Icon Header */}
        <div style={{ marginBottom: 16 }}>
          <FacebookFilled style={{ fontSize: 48, color: "#1877F2" }} />
        </div>

        {/* Title */}
        <h2 style={{ margin: "0 0 8px", fontWeight: 600, color: "#222" }}>
          Recommended - Connect Your Facebook Page
        </h2>

        <Flex align="center" gap={10} style={{ marginBottom: 12 }}>
          <SafetyCertificateFilled style={{ color: "green", fontSize: 20 }} />
          <span style={{ color: "#555", fontSize: 14 }}>
            Improved account safety and trust.
          </span>
        </Flex>

        <div style={{ textAlign: "left", marginBottom: 24 }}>
          <Flex align="center" gap={10} style={{ marginBottom: 12 }}>
            <CheckCircleOutlined style={{ color: "#1877F2", fontSize: 20 }} />
            <span style={{ color: "#555", fontSize: 14 }}>
              Improve comment delivery and reliability.
            </span>
          </Flex>

          <Flex align="center" gap={10} style={{ marginBottom: 12 }}>
            <ThunderboltFilled style={{ color: "#3a0efcff", fontSize: 20 }} />
            <span style={{ color: "#555", fontSize: 14 }}>
              Respond to users faster with automation.
            </span>
          </Flex>

          <Flex align="center" gap={10}>
            <MessageOutlined style={{ color: "#1877F2", fontSize: 20 }} />
            <span style={{ color: "#555", fontSize: 14 }}>
              Automatically manage Facebook comments and DMs.
            </span>
          </Flex>
        </div>


        {/* Buttons */}
        <Flex wrap={'wrap-reverse'} justify="center" gap={12}>
          <Button
            type="default"
            onClick={() => {
              window.location.reload();
            }}
          >
            I’ll do it later
          </Button>
          <Button
            type="primary"
            href="/ig-connect"
            style={{
              background: "#1877F2",
              borderColor: "#1877F2",
              fontWeight: 500,
            }}
          >
            Connect Facebook Page
          </Button>
        </Flex>
      </div>
    </div>
  );
}

function Sider(props) {
  const { TextArea } = Input;
  const [open, setOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [feedbacktext, setFeedbackText] = useState('')

  const [showReconnect, setShowReconnect] = useState()

  const [showSettings, setShowSettings] = useState()

  const [showTeams, setShowTeams] = useState()

  const [settingsPayload, setSettingsPayload] = useState()
  const [loading, setLoading] = useState()

  const [initialSettingPayload, setInitalSettingPayload] = useState()
  const [settingsApiUpdate, setSettingsApiUpdated] = useState()
  const [updateLoading, setupdateLoading] = useState()

  const [showCreateAccount, setShowCreateAccount] = useState()

  const token = localStorage.getItem("token")


  const location = useLocation();

  const [showPlanModal, setShowPlanModal] = useState(props?.showPlan || false)

  const [decodedToken, setDecodeToken] = useState()

  const localStoreConnectedAccount = JSON.parse(localStorage.getItem("connected_accounts"))

  const [connectedAccounts, setConnectedAccounts] = useState(localStoreConnectedAccount)
  const [connectedAccountsLoading, setConnectedAccountsLoading] = useState(localStoreConnectedAccount)

  // Collab Invite Logic
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [inviteData, setInviteData] = useState(null);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteProcessing, setInviteProcessing] = useState(false);

  useEffect(() => {
    const pendingInviteId = localStorage.getItem("pending_collab_invite_id");
    if (pendingInviteId) {
      const fetchInvite = async () => {
        try {
          setInviteLoading(true);
          const docRef = doc(fireDB, "collab_invitations", pendingInviteId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            // check if already accepted
            if (data.status === 'accepted') {
              localStorage.removeItem("pending_collab_invite_id");
              return;
            }
            setInviteData({ id: docSnap.id, ...data });
            setInviteModalOpen(true);
          } else {
            localStorage.removeItem("pending_collab_invite_id");
          }
        } catch (err) {
          console.error("Error fetching pending invite:", err);
        } finally {
          setInviteLoading(false);
        }
      };

      // Delay slightly to ensure user data is ready if needed, or just run immediately
      fetchInvite();
    }
  }, []);

  const handleApproveInvite = async () => {
    if (!inviteData) return;
    setInviteModalOpen(false);
    localStorage.removeItem("pending_collab_invite_id");
    // Redirect to manage-post page to review request
    window.location.href = `/manage-post/${inviteData.post.id}?invite_id=${inviteData.id}&action=review`;
  };

  const handleDeclineInvite = () => {
    setInviteModalOpen(false);
    localStorage.removeItem("pending_collab_invite_id");
  };


  const [createLinkedAccount, setCreateLinkedAccount] = useState()
  const [createLinkedAccountLoding, setCreateLinkedAccountLoading] = useState()
  const [linkAccountData, setLinkAccountData] = useState({})


  const [userPlan, setUserPlan] = useState({})
  const [userPlanLoading, setUserPlanLoading] = useState(false)
  const [userUsageLoading, setLoadingUserUsage] = useState(false)
  const [userUsage, setUserUsage] = useState({})

  const [showMenuDrawer, setShowMenuDrawerMobile] = useState(false)



  let default_automation_temp = {
    "sp_id": null,
    "default_template": true,
    "user_id": "2b0da053-e0da-422f-bf54-f347a17f69e9",
    "auto_reply": {
      "dm_template_type": "text",
      "buttons": [{ "title": "click to edit", "type": "web_url", "url": "" }],
      "reply_comments": ["Thanks for comment❤️, check your dm.", "Sent ✅", "Check DM 📧"],
      "automate_all": "false", "enable": true,
      "triger_words": ["Link", "tool", "doc", "🔗", "demo"], "welcome_message": { "enabled": true, "text": "Hey, It worked. Now click the below button to get your link", "button_text": "Send me Link" }, "dms": ["https://instantdm.com"], "enable_dm_reply": true, "enable_comment_reply": true, "followers_only": true, "ask_follow": { "title": "Hmm, Looks like you haven't followed me. Follow me and click the followed button.", "description": "You can unfollow me later, But now follow me for link.", "button_text": "I Followed you" }, "dm_reply_type": "sequence", "messages": [{ "type": "text", "delay": 0, "dms": ["Cool, you followed me! You can send link, text, images and audios using instantDM."], "buttons": [{ "title": "click to edit", "url": "", "type": "web_url" }] }, { "type": "image", "delay": 0, "dms": [""], "buttons": [{ "title": "click to edit", "url": "", "type": "web_url" }], "image_url": "https://public-assets.instantdm.com/instantdm/public/a4be5f83-f9f3-46af-8924-3182a54d4cea_18014089883569864/media/file.png" }, { "type": "audio", "delay": 0, "dms": [""], "buttons": [{ "title": "click to edit", "url": "", "type": "web_url" }], "audio_url": "https://public-assets.instantdm.com/instantdm/public/15d68351-776e-4532-a95d-b18258762ba3_18014089883569864/media/file.wav" }, { "type": "button", "delay": 0, "dms": [""], "buttons": [{ "title": "InstantDM website", "url": "https://instantdm.com", "type": "web_url" }, { "title": "InstantDM IG", "url": "https://instagram.com/instant.dm", "type": "web_url" }], "title": "You can even track button clicks and audience locations", "subtitle": "Click below to access the dashboard" }]
    }, "post_id": "18014089883569864", "shopify_linked": false, "auto_hide": { "enable": false, "triger_words": [], "ai_analysis": [] }, "automated_at": "2025-10-17 08:10:01.315216", "flow_editor": false, "auto_delete": { "enable": false, "triger_words": [], "ai_analysis": [] }
  }


  let flow_editor_default_temp = {
    "nodes": [
      {
        "id": "node-1",
        "type": "triggerComp",
        "position": {
          "x": -160,
          "y": 40
        },
        "data": {
          "auto_reply": {
            "dm_reply": {
              "enabled": true,
              "triger_words": [
                "Price",
                "Course"
              ]
            },
            "story_reply": {},
            "comment_reply": {},
            "welcome_message": {
              "title": "",
              "description": "",
              "button": ""
            }
          }
        },
        "measured": {
          "width": 130,
          "height": 107
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "node-3",
        "type": "messageReply",
        "position": {
          "x": 160,
          "y": -40
        },
        "data": {
          "toogleDrawer": false,
          "messages": [
            {
              "id": 1,
              "type": "text",
              "smartReplies": [],
              "templates": [],
              "text": "Hey, It's working,\nYou can send multiple messages. Such as\n1. Images,\n2. Buttons,\n3. Audios,\n4. Just Text",
              "audio_url": "",
              "image_url": ""
            },
            {
              "id": 1760788283276,
              "type": "text",
              "smartReplies": [],
              "templates": [],
              "text": "Also you can collect Emails, Phone numbers, ratings, address and more details without leaving Instagram.",
              "audio_url": "",
              "image_url": ""
            },
            {
              "id": 1760788326829,
              "type": "audio",
              "smartReplies": [],
              "templates": [],
              "text": "",
              "audio_url": "https://public-assets.instantdm.com/instantdm/public/e072aa58-1fde-4408-8ba2-09f87da83e89/media/file.wav",
              "image_url": ""
            },
            {
              "id": 1760788170137,
              "type": "text",
              "smartReplies": [
                "Send me follow up message!"
              ],
              "templates": [],
              "text": "And you can send a follow a follow up message.",
              "audio_url": "",
              "image_url": ""
            }
          ]
        },
        "measured": {
          "width": 150,
          "height": 540
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "node-3-1760788210245",
        "type": "messageReply",
        "position": {
          "x": 520,
          "y": -80
        },
        "data": {
          "messages": [
            {
              "id": 1760788217105,
              "type": "text",
              "smartReplies": [],
              "templates": [],
              "text": "Ok, we'll send follow up after few mins.",
              "audio_url": "",
              "image_url": ""
            },
            {
              "id": 1760788246615,
              "type": "delay",
              "delayDuration": 2,
              "durationType": "m"
            },
            {
              "id": 1760788253009,
              "type": "text",
              "smartReplies": [],
              "templates": [],
              "text": "Hey, It's a Follow up message. After few minutes.",
              "audio_url": "",
              "image_url": ""
            }
          ],
          "toogleDrawer": false
        },
        "measured": {
          "width": 160,
          "height": 342
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "source": "node-1",
        "sourceHandle": "node-1-right",
        "target": "node-3",
        "targetHandle": "node-3-left",
        "type": "custom-edge",
        "markerEnd": {
          "type": "arrowclosed"
        },
        "data": {},
        "id": "xy-edge__node-1node-1-right-node-3node-3-left"
      },
      {
        "source": "node-3",
        "sourceHandle": "1760788170137-0-right",
        "target": "node-3-1760788210245",
        "targetHandle": "node-3-1760788210245-left",
        "type": "custom-edge",
        "markerEnd": {
          "type": "arrowclosed"
        },
        "data": {},
        "id": "xy-edge__node-31760788170137-0-right-node-3-1760788210245node-3-1760788210245-left"
      }
    ],
    "name": "[DEFAULT] Welcome Demo"
  }

  const [accountType, setAccountType] = useState("creator")

  let default_img = "https://public-assets.instantdm.com/instandm/pro_pic/empty/pro-pic.png";

  let plan_limit = { "428338": { "max_rate": 1500 }, "428337": { "max_rate": 1500 }, "000003": { "max_rate": 800 }, "0000031": { "max_rate": 800 } }

  const SliderFormat = (value) => {
    if (value < 60) {
      return `${value} Mins`;
    } else {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      return `${hours} Hr ${minutes} Mins`;
    }
  }

  const yt_vids = [
    {
      key: '1',
      label: 'English',

      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/fGweVnU99x0?si=8m1cTZ2zMiYsUDUt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
    // {
    //   key: '2',
    //   label: 'தமிழ்',
    //   children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    // {
    //     key: '3',
    //     label: 'తెలుగు',
    //     children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    {
      key: '4',
      label: 'हिंदी',
      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/v2Zy8hgyaps?si=HNOuC6J-sgNoIX38" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
  ];




  useEffect(() => {

    if (props?.showPlan == undefined) {
      return
    }
    setShowPlanModal(props?.showPlan)

  }, [props?.showPlan])

  // Settings started

  useEffect(() => {
    if (settingsApiUpdate?.code == 200) {
      setShowSettings(false)
      message.success("Settings Updated")
    }
    if (settingsApiUpdate?.code != undefined && settingsApiUpdate?.code != 200) {
      message.error("Settings not updated")
    }

  }, [settingsApiUpdate])

  useEffect(() => {

    if (initialSettingPayload?.shopify_store) {
      localStorage.setItem("shopify_store", initialSettingPayload?.shopify_store)
    }

  }, [initialSettingPayload])

  useEffect(() => {


    if (settingsPayload?.data != undefined) {


      // if(settingsPayload?.data?.not_activated && igPosts?.length < 1){


      //to-do
      // if(!settingsPayload?.not_activated && igPosts?.length < 1){
      // callAPI({
      //   url: "ig-posts?source=sidebar",

      //   method: "GET",

      //   loadingState: (data) => {},

      //   dataState: (data_) => {
      //     const incoming = data_?.posts_lists?.data || [];  
      //     setIGPosts(incoming);
      //     if(incoming?.length > 0)
      //     {
      //     console.log("========incoming length" , incoming?.length)

      //       callAPI({ url: "automate-post", method: "POST", body: {...default_automation_temp, post_id : incoming[0]["id"], user_id: decodedToken?.user_id }, loadingState: () => {}, dataState: () => {} })
      //     }
      //   }
      // });

      //   const upladFlowEditorData = async () => {
      //   let newId = "default-1-auto"
      //     callAPI({ url: `flow_editor?flow_id=${newId}`, method: "POST", body: {...flow_editor_default_temp}, loadingState: () => {}, dataState: () => {} })

      //     const userId = decodedToken?.user_id;
      //     const newAutomation = {
      //         ...flow_editor_default_temp,
      //         id: newId,
      //         live: true,
      //         published_on: `${new Date()}`,

      //     };

      //     const docRef = doc(fireDB, "automations", userId, "draft_automations", newId);
      //     await setDoc(docRef, newAutomation);
      //   };

      //     upladFlowEditorData();

      // }



      // {"automation_setting": {"dm_automation": "true", "account_automation": "true", "comment_automation": "true"}}

      setInitalSettingPayload(settingsPayload?.data)
      setSettingsPayload(settingsPayload?.data)

      if ((connectedAccounts == null || connectedAccounts == undefined || connectedAccounts?.accounts.length == 0) && localStorage.getItem("agency-token")) {
        let apiURL = '/list-agency-account'

        callAPI({ url: apiURL, method: "GET", loadingState: setConnectedAccountsLoading, dataState: setConnectedAccounts, need_admin_token: true })
      }
      if (connectedAccounts?.users) {
        localStorage.setItem("connected_accounts", JSON.stringify({ "accounts": connectedAccounts.users }))
        setConnectedAccounts({ "accounts": connectedAccounts.users })
      }
      else {
        return
      }

    }

  }, [settingsPayload])

  useEffect(() => {

    if (!connectedAccounts) {
      return
    }
    if (connectedAccounts?.refresh) {
      console.log("Refreshing")
      let apiURL = '/list-agency-account'
      callAPI({ url: apiURL, method: "GET", loadingState: setConnectedAccountsLoading, dataState: setConnectedAccounts, need_admin_token: true })
      return
    }
    if (connectedAccounts?.users) {
      localStorage.setItem("connected_accounts", JSON.stringify({ "accounts": connectedAccounts.users }))
      setConnectedAccounts({ "accounts": connectedAccounts.users })
    }
    else {
      return
    }

  }, [connectedAccounts])



  useEffect(() => {
    let apiURL = 'account-setting'
    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setSettingsPayload })
    let apiURL2 = `user_plan`
    callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })
    apiURL = `ig-usage-stat?tz=${user_tz}`
    callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })





  }, [])

  // Track paid subscription to Meta Pixel (only for paid plans, only once per user)
  useEffect(() => {
    if (!userPlan?.data || userPlanLoading) return;

    const planId = userPlan.data?.plan_details?.id;
    const planName = userPlan.data?.plan_details?.name;
    const userId = decodedToken?.user_id;
    const userEmail = userPlan.data?.emailid;

    // Only track if user is on a paid plan (not free)
    if (planId && planId !== 'free' && userId) {
      trackSubscription(
        {
          userId: userId,
          planId: planId,
          planName: planName || planId,
          value: 0, // You can add actual subscription value if available
          currency: 'USD'
        },
        {
          email: userEmail,
          external_id: userId,
          firstName: decodedToken?.name?.split(' ')[0]
        }
      );
    }
  }, [userPlan, userPlanLoading, decodedToken])

  useEffect(() => {
    try {
      window.createLemonSqueezy()
    }
    catch (e) {

    }

  }, [])

  useEffect(() => {
    new Promise((resolve, reject) => {
      if (window.Razorpay) {
        return resolve(true);
      }

      const script = document.createElement('script');
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);  // Resolve once the script is loaded
      script.onerror = (err) => reject(new Error("Razorpay script failed to load"));

      document.body.appendChild(script);
    });
  })



  useEffect(() => {

    if (linkAccountData?.data) {
      message.success("New Account Created")
      message.destroy()
      localStorage.setItem("token", linkAccountData?.data?.token)
      sessionStorage.clear();
      setConnectedAccounts({ accounts: [...connectedAccounts.accounts, linkAccountData?.data] })
      localStorage.setItem("connected_accounts", JSON.stringify({ accounts: [...connectedAccounts.accounts, linkAccountData?.data] }))
      setLinkAccountData({})
      setCreateLinkedAccountLoading(false)
      setCreateLinkedAccount(false)
      window.location.reload();
    }

  }, [linkAccountData])

  useEffect(() => {

    if (!createLinkedAccount) {
      return
    }
    message.loading("Creating new account...")
    let apiURL = '/create-agency-linked-account'
    callAPI({ url: apiURL, method: "PUT", loadingState: setCreateLinkedAccountLoading, dataState: setLinkAccountData, need_admin_token: true })

  }, [createLinkedAccount])



  const updateSettingsAPI = () => {
    let apiURL = `/account-setting`
    callAPI({ url: apiURL, method: "PUT", body: settingsPayload, loadingState: setupdateLoading, dataState: setSettingsApiUpdated })

  }

  const updateAutomationData = (key, value) => {


    if (key == "account_automation") {
      setSettingsPayload({
        ...settingsPayload,
        automation_setting: {
          ...settingsPayload.automation_setting,
          account_automation: value,
          dm_automation: value,
          comment_automation: value
        },
      });
      return
    }


    if (key == "plan_rate_limit") {
      setSettingsPayload({
        ...settingsPayload,
        plan_details: {
          ...settingsPayload.plan_details,
          [key]: value
        },
      });
      return
    }

    setSettingsPayload({
      ...settingsPayload,
      automation_setting: {
        ...settingsPayload.automation_setting,
        [key]: value,
      },
    });
  };

  function Avatar({ src, name }) {
    const [error, setError] = useState(false);

    return (
      <div>
        {error ? (
          <div className="avatar">{name != undefined ? name[0] : "C"}</div>
        ) : (
          <img src={src} onError={() => setError(true)} />
        )}
      </div>
    );
  }

  const [paymentLinkLoading, setPaymentLinkLoading] = useState()
  const [paymentLinkData, setPaymentLinkData] = useState({})

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [updateEmail, setUpdateEmail] = useState(false)
  const [newEmail, setNewEmail] = useState()
  const [updateEmailLoading, setUpdateEmailLoading] = useState()
  const [emailIDUpdateData, setEmailIDUpdateData] = useState({})
  const [whatsappNumber, setWhatsappNumber] = useState()


  const [currentAutomateStep, setCurrentAutomateStep] = useState(-1);

  const [igPosts, setIGPosts] = useState([]);

  const [showMobileMenuTip, setShowMobileMenuTip] = useState(true);
  const [showNewMenuTip, setShowNewMenuTip] = useState(true);

  // First Automation Onboarding (Aha moment)
  const [firstAutomationCompleted, setFirstAutomationCompleted] = useState(
    () => localStorage.getItem('firstAutomationCompleted') === 'true'
  );

  // Onboarding Pricing Popup
  const [showOnboardingPricing, setShowOnboardingPricing] = useState(false);


  const [collapsed, setCollapsed] = useState(() => {
    const stored = localStorage.getItem("sideCollapsed");
    return stored !== null ? JSON.parse(stored) : true;
  });

  useEffect(() => {
    localStorage.setItem("sideCollapsed", JSON.stringify(collapsed));
  }, [collapsed]);


  useEffect(() => {
    const t = setTimeout(() => {
      setShowMobileMenuTip(false);
    }, 3000); // hides after 10 seconds

    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      setShowNewMenuTip(false);
    }, 5000); // hides after 10 seconds

    return () => clearTimeout(t);
  }, []);
  // const [selectedKey, setSelectedKey] = useState('1');

  // useEffect(() => {

  //   if(currentAutomateStep == 2){
  //     callAPI({ url: "automate-post?demo=true", method: "POST", body: {...default_automation_temp, post_id : igPosts?.[0]?.id, user_id: decodedToken?.user_id, auto_reply:{...default_automation_temp.auto_reply,enable:false } }, loadingState: () => {}, dataState: () => {} })

  //     callAPI({ url: "flow_editor?flow_id=default-1-auto&demo=true", method: "DELETE", body: {}, loadingState: () => {}, dataState: () => {} })

  //     const upladFlowEditorData = async () => {
  //     let newId = "default-1-auto"

  //       const userId = decodedToken?.user_id;
  //       const newAutomation = {
  //           ...flow_editor_default_temp,
  //           id: newId,
  //           live: false,
  //           published_on: `${new Date()}`,

  //       };

  //       const docRef = doc(fireDB, "automations", userId, "draft_automations", newId);
  //       await setDoc(docRef, newAutomation);
  //     };

  //       upladFlowEditorData();

  //   }
  // },[currentAutomateStep])


  useEffect(() => {



    if (emailIDUpdateData?.message) {
      message.destroy()
      setUpdateEmail(false)
      if (emailIDUpdateData?.code != "200") {
        message.error(emailIDUpdateData?.message)
        setEmailIDUpdateData({})
      }
      else {
        // Track Meta Pixel: User completed signup (finished onboarding with email)
        // Pass user data for Advanced Matching
        trackCompletedSignup({
          email: newEmail,
          phone: whatsappNumber,
          external_id: decodedToken?.user_id,
          firstName: decodedToken?.name?.split(' ')[0]
        });

        localStorage.setItem("token", emailIDUpdateData.token);
        sessionStorage.clear();
        localStorage.removeItem("refCode");
        // message.success(emailIDUpdateData?.message)
        // confetti({
        //   particleCount: 400,
        //   spread: 150,
        //   origin: { y: 0.6 }
        // });

        // Delay reload to allow confetti to show
        setTimeout(() => {
          localStorage.setItem("token", emailIDUpdateData.token);
          sessionStorage.clear();
          localStorage.removeItem("refCode");
          // window.location.reload();
        }, 1200);
      }



    }
  }, [emailIDUpdateData])

  useEffect(() => {
    if (updateEmailLoading == true) {
      message.loading("Please Wait")
    }
  }, [updateEmailLoading])

  useEffect(() => {

    if (!updateEmail) {
      return
    }


    let apiURL = '/update_email'
    callAPI({
      url: apiURL, method: "PUT", body: {
        "emailid": newEmail,
        "whatsapp_number": whatsappNumber,
        "email_verified": true,

        previous_tools: [...onboardingData?.step1, onboardingData?.step1_other || ''],
        instagram_use: [...onboardingData?.step2, onboardingData?.step2_other || ''],
        main_goal: onboardingData?.step3,
        other_tools: onboardingData?.step4,
        website: onboardingData?.step5,

      }, loadingState: setUpdateEmailLoading, dataState: setEmailIDUpdateData
    })

  }, [updateEmail])

  function decodeTokenJWT(token) {
    let jwt_token = jwtDecode(token)
    // console.log("JWT TOKEN", jwt_token)
    let final_data = {}

    if (jwt_token?.default_page?.connected_instagram_account != undefined) {
      final_data = jwt_token?.default_page?.connected_instagram_account

    }
    else {
      final_data = jwt_token["default_page"]
    }

    final_data["agency"] = jwt_token?.agency
    final_data["user_id"] = jwt_token?.user_id
    final_data["name"] = jwt_token?.name
    return final_data
  }
  useEffect(() => {



    let final_data = decodeTokenJWT(token)
    setDecodeToken(final_data)
  }, [])

  useEffect(() => {

    if (paymentLinkData?.open_url) {

      window.location.href = paymentLinkData?.payment_url
      return

    }

    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ",
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id,
          handler: function (response) {
            setShowPlanModal(false)

            message.success("Payment completed, Please wait while we're verfiying!")
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            let igid = localStorage.getItem("ig_id")

            const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
            const CHAT_ID = '776956029';
            const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
            let tele_message = `[SUBSCRIBED PLAN] - user ${user_detail.emailid}  - Subscribed for  , IG ID = ${igid} , user id = ${user_detail.user_id}`
            let data = {
              chat_id: CHAT_ID,
              text: tele_message
            };


            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
              .then(response => response.json())
              .then(data => {
                console.log('Message sent successfully:', data);
              })
              .catch(error => {
                console.error('Error sending message:', error);
              });
            setPaymentLinkData({})
          },
          error: function (response) {
            // setShowPlanModal(false)
            message.error("Payment Failed, Please try again later!")
            setPaymentLinkData({})
            // setShowWaitingPaymentFailed(true)
            // alert("Payment Failed: " + response.error.description);
          },
          modal: {
            ondismiss: function () {
              message.error("Payment Cancelled, Please try again!")
              setPaymentLinkData({})
            }
          },
          prefill: {
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  const handleLogout = () => {
    // Clear all localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key !== "previous_config") {
        localStorage.removeItem(key);
      }
    });
    sessionStorage.clear()
    // Redirect to the login page
    window.location.href = '/login';
  };

  const { Step } = Steps;

  const [currentStep, setCurrentStep] = useState(-1);

  // Trigger regular onboarding when user is not activated (instead of FirstAutomationOnboarding)
  useEffect(() => {
    if (settingsPayload?.not_activated && !firstAutomationCompleted && currentStep < 0) {
      setCurrentStep(0);
      localStorage.setItem('firstAutomationCompleted', 'true');
      setFirstAutomationCompleted(true);
    }
  }, [settingsPayload?.not_activated, firstAutomationCompleted, currentStep]);
  const [onboardingData, setOnboardingData] = useState({
    step1: undefined,
    step2: undefined,
    step3: undefined,
    step4: undefined,
    step5: undefined,
  });

  // OTP Verification States
  const [otpStep, setOtpStep] = useState('email'); // 'email' or 'verify'
  const [otp, setOtp] = useState('');
  const [otpTimer, setOtpTimer] = useState(0);
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);

  // OTP Timer countdown
  useEffect(() => {
    let interval = null;
    if (otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((timer) => timer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpTimer]);

  // Send OTP to email
  const handleSendOtp = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      message.error('Please enter a valid email address');
      return;
    }

    setOtpSending(true);
    message.loading({ content: 'Sending OTP to your email...', key: 'otp-send' });

    callAPI({
      url: `register_otp_email?email_id=${newEmail}`,
      method: 'PUT',
      body: {},
      loadingState: setOtpSending,
      dataState: (data) => {
        message.destroy('otp-send');
        if (data?.code === 200) {
          message.success('OTP sent to your email!');
          setOtpStep('verify');
          setOtpTimer(60);
          setOtp('');
        } else {
          message.error(data?.message || 'Failed to send OTP. Please try again.');
        }
      }
    });
  };

  // Verify OTP and proceed to account creation
  const handleVerifyOtp = () => {
    if (!otp || otp.length !== 6) {
      message.error('Please enter the 6-digit OTP');
      return;
    }

    setOtpVerifying(true);
    message.loading({ content: 'Verifying OTP...', key: 'otp-verify' });

    callAPI({
      url: 'register_otp_verify',
      method: 'PUT',
      body: { otp, email_id: newEmail },
      loadingState: setOtpVerifying,
      dataState: (data) => {
        message.destroy('otp-verify');
        if (data?.code === 200) {
          message.success('Email verified successfully!');
          // Proceed to create account
          setUpdateEmail(true);
        } else {
          message.error(data?.message || 'Invalid OTP. Please try again.');
        }
      }
    });
  };

  // Reset OTP flow
  const resetOtpFlow = () => {
    setOtpStep('email');
    setOtp('');
    setOtpTimer(0);
  };

  const onboardingSteps = [
    {
      // title: 'Previous Tools',

      content: (
        <div>
          <h3>Have you used any of these tools before?</h3>
          <Checkbox.Group
            size="large"
            style={{ width: "100%", marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px" }}
            value={onboardingData.step1}
            onChange={value => setOnboardingData(prev => ({ ...prev, step1: value }))}
            placeholder="Have you used any of these tools before?"
            options={[
              { label: "Manychat", value: "manychat" },
              { label: "Linkdm", value: "linkdm" },
              { label: "Zorcha", value: "zorcha" },
              { label: "Super Profile", value: "superprofile" },
              { label: "Inro", value: "inro" },
              { label: "Reply Rush", value: "replyrush" },
              { label: "Nothing", value: "none" },
              { label: "Other", value: "other" },
            ]}
          />
          {onboardingData.step1?.includes("other") && (
            <Input
              style={{ marginTop: 12 }}
              placeholder="Please specify other tool(s)"
              value={onboardingData.step1_other || ""}
              onChange={e =>
                setOnboardingData(prev => ({ ...prev, step1_other: e.target.value }))
              }
            />
          )}
        </div>
      ),
    },
    {
      // title: 'Instagram Use',

      content: (
        <div>
          <h3>What suits you best?</h3>
          <Checkbox.Group
            style={{ width: "100%", marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px" }} value={onboardingData.step2}
            onChange={value => setOnboardingData(prev => ({ ...prev, step2: value }))}
            placeholder="What do you use Instagram for?"
            options={[
              { label: "Online Store", value: "online_store" },
              { label: "Offline Store", value: "offline_store" },
              { label: "Content Creator", value: "creator" },
              { label: "UGC Creator", value: "ugc_creator" },
              { label: "Fashion Creator", value: "fashion_creator" },
              { label: "Influencer", value: "influencer" },
              { label: "Affiliate Partner", value: "affiliate" },
              { label: "Coaching / Consulting", value: "coaching" },
              { label: "Marketing Agency", value: "agency" },
              { label: "Digital Marketing", value: "digital_marketing" },
              { label: "Service Company", value: "service_company" },
              { label: "Real Estate / High-Ticket Sales", value: "real_estate" },
              { label: "Brand", value: "brand" },
              { label: "Other", value: "other" }
            ]}
          />
          {onboardingData.step2?.includes("other") && (
            <Input
              style={{ marginTop: 12 }}
              placeholder="Please specify"
              value={onboardingData.step2_other || ""}
              onChange={e =>
                setOnboardingData(prev => ({ ...prev, step2_other: e.target.value }))
              }
            />
          )}
        </div>
      ),
    },
    {
      // title: 'Main Goal',
      content: (
        <div>

          <h3>What is your main goal with InstantDM?</h3>
          <Checkbox.Group

            style={{ width: "100%", marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px" }}
            value={onboardingData.step3}
            onChange={value => setOnboardingData(prev => ({ ...prev, step3: value }))}
            placeholder="Your main goal with InstantDM"
            options={[
              { label: "Increase product sales", value: "sales" },
              { label: "Get more leads / calls", value: "leads" },
              { label: "Grow my followers", value: "followers" },
              { label: "Engage with my audience", value: "engagement" }
            ]}
          />
        </div>
      ),
    },
    {
      // title: 'Other Tools',
      question: "Are you using any of these tools currently?",
      content: (
        <div>
          <h3>Are you using any of these tools currently?</h3>
          <Checkbox.Group
            style={{ width: "100%", marginTop: "20px", display: "flex", flexDirection: "column", gap: "8px" }}
            value={onboardingData.step4}
            onChange={value => setOnboardingData(prev => ({ ...prev, step4: value }))}
            placeholder="Are you using any of these tools currently?"
            options={[
              { label: "Shopify", value: "shopify" },
              { label: "Open in App", value: "open_in_app" },
              { label: "Link.ID", value: "link_id" },
              { label: "Super Profile", value: "superprofile" },
              { label: "Link Tree", value: "linktree" },
              { label: "Bento", value: "bento" },
              { label: "Wordpress / Woo-Commerce", value: "wordpress" },
              { label: "Nothing", value: "none" }
            ]}
          />
        </div>
      ),
    },
    {
      // title: 'Website',
      question: "Do you have a website?",
      content: (
        <div>
          <h3>Do you have a website?</h3>
          <Input
            prefix={<GlobalOutlined />}
            value={onboardingData.step5 || ""}
            onChange={(e) => setOnboardingData(prev => ({ ...prev, step5: e.target.value }))}
            placeholder='Please share your website link'
            style={{ marginTop: "20px" }}
          />
        </div>
      ),
    },
    {
      // title: 'WhatsApp',
      content: (
        <div>
          <h3>What's your WhatsApp number? <Tag color="blue">Optional</Tag></h3>
          <p style={{ color: '#666', fontSize: '13px', marginBottom: '12px' }}>We'll use this for important updates and support</p>
          <PhoneInput
            international
            countryCallingCodeEditable={false}
            defaultCountry="IN"
            value={whatsappNumber}
            onChange={setWhatsappNumber}
            placeholder="Enter your WhatsApp number"
            style={{ marginTop: '10px' }}
            className="phone-input-wrapper"
          />
        </div>
      ),
    },
    {
      // title: 'Email',
      content: (
        <div>
          {otpStep === 'email' ? (
            <>
              <h3>Enter your email address</h3>
              <p style={{ color: '#666', fontSize: '13px', marginBottom: '12px' }}>We'll send a verification code to confirm your email</p>
              <Input
                prefix={<MailOutlined />}
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                placeholder='Enter your email address'
                style={{ marginTop: "10px" }}
                size="large"
                disabled={otpSending}
                onPressEnter={handleSendOtp}
              />
              <Button
                type="primary"
                size="large"
                block
                style={{ marginTop: '16px' }}
                onClick={handleSendOtp}
                loading={otpSending}
                disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)}
              >
                Send Verification Code
              </Button>
            </>
          ) : (
            <>
              <h3>Enter verification code</h3>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#f5f5f5',
                padding: '8px 12px',
                borderRadius: '8px',
                marginBottom: '12px'
              }}>
                <span style={{ fontSize: '13px' }}>OTP sent to: <strong>{newEmail}</strong></span>
                <Button
                  type="link"
                  size="small"
                  onClick={resetOtpFlow}
                  style={{ padding: 0 }}
                >
                  Change
                </Button>
              </div>
              <p style={{ color: '#888', fontSize: '12px', marginBottom: '16px' }}>📧 Can't find the email? Check your spam folder</p>

              <Input.OTP
                length={6}
                value={otp}
                onChange={(value) => setOtp(value)}
                size="large"
                disabled={otpVerifying}
                style={{ width: '100%' }}
              />

              <Button
                type="primary"
                size="large"
                block
                style={{ marginTop: '16px' }}
                onClick={handleVerifyOtp}
                loading={otpVerifying}
                disabled={otp.length !== 6}
              >
                Verify & Create Account
              </Button>

              <div style={{ textAlign: 'center', marginTop: '12px' }}>
                {otpTimer > 0 ? (
                  <span style={{ color: '#888', fontSize: '13px' }}>Resend OTP in {otpTimer}s</span>
                ) : (
                  <Button
                    type="link"
                    onClick={handleSendOtp}
                    loading={otpSending}
                    style={{ padding: 0, fontSize: '13px' }}
                  >
                    Resend OTP
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  const planAutomationLimits = {
    "starter-quart": 100,
    "starter-year": 100,
    "legend-two-month": 400,
    "566423": 600,
    "000003": 800,
    "0000031": 800,
    "428337": 2000,
    "428338": 2000,
    "trendsetter-pro-monthly": 20000,
    "trendsetter-pro-yearly": 20000
  };

  const automationOptions = [
    { label: "100 Automation", value: 100 },
    { label: "400 Automation", value: 400 },
    { label: "800 Automation", value: 800 },
    { label: "1500 Automation", value: 1500 },
    { label: "2000 Automation", value: 2000 },
    { label: "2500 Automation", value: 2500 },
    { label: "3000 Automation", value: 3000 },
    { label: "Maximum Allowed", value: 20000 },
  ];

  // Get max allowed automation for the current plan
  const planId = 'legend-two-month' //settingsPayload?.plan_details?.id || 'starter-quart';
  const maxAllowed = planAutomationLimits[planId] ?? 800;

  // Filter and disable based on max allowed
  const filteredOptions = automationOptions.map((opt) => ({
    ...opt,
    disabled: opt.value > maxAllowed,
  }));

  // Set default value smartly
  const defaultAutomation = Number(
    settingsPayload?.plan_details?.plan_rate_limit ??
    filteredOptions
      .filter(o => !o.disabled)
      .map(o => o.value)
      .sort((a, b) => b - a)[0] // highest allowed value
  );


  function SwitchAccountPopover({ returnAvatarOnly }) {


    if (localStorage.getItem("agency-token")) {


      return <>
        <Popover placement='top' content={
          <div style={{ maxHeight: "400px", display: "flex", flexDirection: "column", overflow: "scroll" }}>

            {
              (connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length > 0) && connectedAccounts.accounts.map((account, index) => (
                <div onClick={() => {
                  sessionStorage.clear();
                  localStorage.setItem("token", account.token)
                  localStorage.setItem("userData", JSON.stringify(decodeTokenJWT(account.token)))
                  window.location.href = "/";

                }} style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", cursor: "pointer" }}>
                  <img style={{ height: "40px", width: "40px", borderRadius: '100px' }} key={index} alt={index} src={account?.default_page?.profile_picture_url || default_img} />

                  <p>@{account?.default_page?.username || "Empty"} {(decodedToken?.user_id == account?.user_id) && <CheckCircleTwoTone style={{ color: "green" }} />}</p>
                </div>

              ))
            }

            {(connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length < 50) && <div onClick={() => setCreateLinkedAccount(true)} style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", cursor: "pointer" }}>
              <PlusCircleOutlined style={{ fontSize: "24px", color: "green", cursor: "pointer" }} />
              <p>Add new account</p>
            </div>
            }


            <div onClick={() => {
              localStorage.removeItem("connected_accounts")
              setConnectedAccounts({ "refresh": true, "accounts": [] })

            }} style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", cursor: "pointer" }}>
              <ReloadOutlined style={{ fontSize: "14px", cursor: "pointer" }} />
              <p>Refresh Accounts</p>
            </div>



          </div>
        } >
          {/* <div className='mobile' style={{display:"flex", flexDirection:"row", alignContent:"center", alignItems:"center"}}><img src={`${decodedToken?.profile_picture_url}`} style={{height:'30px', width:'30px', borderRadius:'100px'}} /> </div> */}
          {returnAvatarOnly ?
            <img src={`${decodedToken?.profile_picture_url}`} style={{ height: '30px', width: '30px', borderRadius: '100px' }} /> : <div className='white-bg-border' style={{ padding: "10px" }} >
              <Flex align='center' gap={"20px"} justify='flex-start'>
                <img src={`${decodedToken?.profile_picture_url}`} style={{ height: '60px', width: '60px', borderRadius: '100px' }} />
                <h6 style={{
                  fontSize: "16px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  overflow: "hidden"
                }}>
                  {decodedToken?.username || "Connect IG"}</h6>
                {connectedAccounts?.accounts?.length > 0 && <UpOutlined style={{ border: "1px solid rgba(0,0,0,.5)", padding: "10px", borderRadius: "100px" }} />}
              </Flex>
              {connectedAccounts?.accounts?.length > 0 && <p style={{ opacity: ".6" }}>{connectedAccounts?.accounts.length} More accounts</p>}
            </div>}
        </Popover>

      </>
    }
    else {
      return returnAvatarOnly ?
        <Popover placement='top' content={
          <div style={{ maxHeight: "400px", display: "flex", flexDirection: "column", overflow: "scroll" }}>
            <Flex align='center' gap={"20px"} justify='flex-start'>
              <img src={`${decodedToken?.profile_picture_url}`} style={{ height: '60px', width: '60px', borderRadius: '100px' }} />
              <h6 style={{
                fontSize: "16px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "100%",
                overflow: "hidden"
              }}>
                {decodedToken?.username || "Connect IG"}</h6>
              {connectedAccounts?.accounts?.length > 0 && <UpOutlined style={{ border: "1px solid rgba(0,0,0,.5)", padding: "10px", borderRadius: "100px" }} />}
            </Flex>
          </div>
        } ><img src={`${decodedToken?.profile_picture_url}`} style={{ height: '30px', width: '30px', borderRadius: '100px' }} /></Popover> :
        <>
          <div className='white-bg-border' style={{ padding: "10px" }} >
            <Flex align='center' gap={"20px"} justify='flex-start'>
              <img src={`${decodedToken?.profile_picture_url}`} style={{ height: '60px', width: '60px', borderRadius: '100px' }} />
              <h6 style={{
                fontSize: "16px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "100%",
                overflow: "hidden"
              }}>
                {decodedToken?.username || "Connect IG"}</h6>
              {connectedAccounts?.accounts?.length > 0 && <UpOutlined style={{ border: "1px solid rgba(0,0,0,.5)", padding: "10px", borderRadius: "100px" }} />}
            </Flex>
            {connectedAccounts?.accounts?.length > 0 && <p style={{ opacity: ".6" }}>{connectedAccounts?.accounts.length} More accounts</p>}

          </div>
        </>

    }
  }

  let menu_icon_style = {
    fontSize: '20px',
    marginRight: '10px',
    color: "rgba(0,0,0,.5)"
  }

  const menuItems = [
    {
      key: '0',
      icon: <HomeOutlined style={menu_icon_style} />,
      label: 'Home',
      path: '/home'
    },

    {
      key: '2s',
      icon: <InstagramOutlined style={menu_icon_style} />,
      label: 'Instagram DM',
      path: '/'
    },
    {
      key: '4',
      icon: <FacebookOutlined style={menu_icon_style} />,
      label: 'Facebook DM',
      path: '/fb'
    },
    {
      key: '3',
      icon: <CalendarOutlined style={menu_icon_style} />,
      label: 'Later',
      path: '/later'
    },
    {
      key: '1',
      icon: <BarChartOutlined style={menu_icon_style} />,
      label: 'Dashboard',
      path: '/dashboard'
    },


    {
      key: '5',
      icon: <LinkOutlined style={menu_icon_style} />,
      label: 'Instant Open',
      path: '/oia'
    },
    {
      key: '6',
      icon: <CrownOutlined style={menu_icon_style} />,
      label: 'My Plan',
      onClick: () => { setShowPlanModal(true) }
    },
    {
      key: '7',
      icon: <DollarOutlined style={menu_icon_style} />,
      label: 'Affiliate & Referral',
      path: '/referral-dashboard'
    },
    {
      key: '8',
      icon: <VideoCameraOutlined style={menu_icon_style} />,
      label: 'Watch Video',
      onClick: () => { setShowVideo(true) }
    },
    {
      key: '9',
      icon: <SettingOutlined style={menu_icon_style} />,
      label: 'Account Settings',
      onClick: () => { setShowSettings(true) }
    },
  ];

  const selectedKey = menuItems
    .filter(item => item.path)
    .sort((a, b) => b.path.length - a.path.length)     // longest path first
    .find(item => location.pathname.startsWith(item.path))
    ?.key;


  return (

    <div>
      {contextHolder}
      <div style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1000 }}>
        {settingsPayload?.connected_accounts?.fb_data?.error && <Alert
          message="Facebook conection expired! Automation Stopped."
          showIcon
          description="Reconnect your facebook page to use the automation features."
          type="error"
          action={
            <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
          }
        />}

        {settingsPayload?.connected_accounts?.ig_data?.error && <Alert
          message="Instagram conection expired! Automation Stopped."
          showIcon
          description="Reconnect your Instagram account to use."
          type="error"
          action={
            <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
          }
        />}
      </div>
      <div className='mobile-nav'>
        <div style={{ flex: 1 }}>
          <Link to='/'>
            <div style={{ display: 'flex', gap: "4px", flexDirection: 'row', alignItems: 'center', marginLeft: '0' }}>
              <img
                src="/logo192.png"
                alt="InstantDM Logo"
                style={{ width: 32, height: 32, marginBottom: 8, marginLeft: '10px' }}
              />
              <h3 className='logo-tex'>iNSTANTDM</h3>
            </div>

          </Link>
        </div>
        <h6 onClick={() => { setShowMenuDrawerMobile(true) }} style={{ fontSize: '16px', color: 'black', padding: '10px' }}><MenuUnfoldOutlined /> <span style={{ marginLeft: '10px' }}>Menu</span></h6>


      </div>


      <Layout className={"desktop"} style={{ minHeight: '100vh', backgroundColor: "white" }}>
        <antSider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={null}
          style={{
            minHeight: '100vh',
            background: collapsed ? "transparent" : "white",
            boxShadow: '2px 0 8px rgba(0,0,0,0.05)'
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            justifyContent: 'space-between'
          }}>
            {/* Header */}
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: collapsed ? 'center' : 'space-between',
                padding: '20px 16px',
                borderBottom: '1px solid #f0f0f0',
                // backgroundColor:"black"
              }}>
                {!collapsed && (
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <img
                      src="/logo192.png"
                      alt="InstantDM Logo"
                      style={{ width: 40, height: 40 }}
                    />
                    <h3 className='logo-tex'  >
                      iNSTANTDM
                    </h3>
                  </div>
                )}
                {collapsed && <img
                  src="/logo192.png"
                  alt="InstantDM Logo"
                  style={{ width: 30, height: 30, marginBottom: 0 }}
                />}


              </div>

              {/* Menu */}
              <Menu
                mode="inline"
                selectedKeys={[selectedKey]}
                inlineCollapsed={collapsed}
                style={{ border: 'none', marginTop: '16px', background: collapsed ? "transparent" : "white" }}
                items={menuItems.map(item => ({
                  ...item,
                  label: item?.path ? <Link to={item?.path}>{item.label}</Link> : item?.label,
                  icon: item?.path ? <Link to={item?.path}>{item.icon}</Link> : item?.icon,
                  onClick: item.onClick || (() => { })
                }))}
              />

            </div>

            {/* Footer */}
            <div style={{
              display: 'flex',
              flexDirection: 'column', padding: '16px', borderTop: '1px solid #f0f0f0'
            }}>

              <div
                onClick={() => { setShowReconnect(true) }}

                style={{
                  cursor: 'pointer',
                  padding: '12px',
                  borderRadius: '8px',
                  background: '#fff2e8',
                  border: '1px solid #ffbb96',
                  marginBottom: '16px',

                }}
              >
                {!collapsed && <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#ff4d4f',
                  fontSize: '14px',
                  fontWeight: 500
                }}>

                  <ExclamationCircleOutlined /> Automation Not working?
                </div>}
                {collapsed && <Tooltip title="Automation Not Working? Click here."> <ExclamationCircleOutlined style={{ color: "red", fontSize: "16px", fontWeight: "600" }} /></Tooltip>}
              </div>
              <SwitchAccountPopover returnAvatarOnly={collapsed} />
              <div
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  cursor: 'pointer',
                  padding: '12px',
                  borderRadius: '8px',
                  background: '#111111ff',
                  border: '1px solid #696c6dff',
                  marginBottom: '16px',
                  marginTop: '16px',
                  color: "white",


                }}
              >

                {collapsed ? <MenuUnfoldOutlined style={{ fontSize: "18px", fontWeight: "bold", }} /> : <div><MenuFoldOutlined style={{ fontSize: "18px", fontWeight: "bold", }} /> Collapse Pannel </div>}
              </div>
            </div>
          </div>
        </antSider>
      </Layout>

      {/* <DraggableTutorial /> */}


      {/* <div>

            {(decodedToken?.agency || decodedToken?.agency_id  || localStorage.getItem("agency-token")) && 
            <div className='switch-accounts'>
            {(connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length < 20 ) && <Tooltip title='Add new account'>
              <PlusCircleOutlined onClick={() => setCreateLinkedAccount(true)} style={{fontSize:"24px", color:"green", cursor:"pointer"}}  />
              </Tooltip>
              }
              {
                (connectedAccounts?.accounts != undefined && connectedAccounts?.accounts.length > 0) && connectedAccounts.accounts.map( (account, index) =>(
                  <Popover placement='top' content={
                    <div style={{display:"flex" , flexDirection:"column"}}>
                      <img key={index} src={account?.default_page?.profile_picture_url  || default_img} style={{width:'100px', height:"100px", borderRadius:"10px"}} />
                      <a href={`https://instagram.com/${account?.default_page?.username}`}>@{account?.default_page?.username || "Not Connected"}</a>
                    </div>
                  } >

                  <div style={{ position: 'relative' }}>
                      <img 
                        key={index} 
                        alt={index} 
                        src={account?.default_page?.profile_picture_url || default_img} 
                        onClick={() => {
                          localStorage.setItem("token", account.token)
                          localStorage.setItem("userData" , JSON.stringify(decodeTokenJWT(account.token)))
                          sessionStorage.clear(); 
                          window.location.reload();
                        }}
                      />
                      {(decodedToken?.user_id  == account?.user_id) && 
                        <CheckCircleTwoTone style={{
                          position: 'absolute', 
                          top: 0, 
                          right: 0, 
                        }}/>
                      }
                    </div>
                  </Popover>
                ))
              }
            <Tooltip title='Reload connected accounts.'>
              <ReloadOutlined 
              
              onClick={() => {
                localStorage.removeItem("connected_accounts")
                setConnectedAccounts({"refresh":true,"accounts":[]})
              }}
              style={{fontSize:"14px", color:"grey", opacity:".8", cursor:"pointer"}}  />
              </Tooltip>
            
            </div>
            }

          <div className='insta-card insta-card-side'>
          <Avatar src={decodedToken?.profile_picture_url} name={decodedToken?.name} />
          <div>
            <Tooltip title={decodedToken?.name ||  decodedToken?.username || "Connect IG"}> 
              <h3>{decodedToken?.username  || decodedToken?.username || "Connect IG"}</h3>
            </Tooltip>
            </div>
          </div>

        </div> */}




      <div className='top-bar'>

      </div>



      <Modal
        title="Product Guide"
        open={showVideo}
        width={800}
        height={600}
        onOk={() => {
          setShowVideo(false)
        }}

        onCancel={() => { setShowVideo(false) }}
      >
        <Tabs defaultActiveKey="1" items={yt_vids} />

      </Modal>

      <Modal
        title="Submit your Feedback"
        open={open}
        onOk={() => {


          setOpen(false)

          // messageApi.open({
          //     key:"1",
          //     type: 'success',
          //     content: 'Thanks for the feedback!',
          //   });
        }}
        // okText = "Submit my feedback"
        confirmLoading={confirmLoading}
        onCancel={() => { setOpen(false) }}
      >
        <p>Hii There, thanks for taking a moment to share feedback. It will really help us to improve our service and product a lot.</p>
        <a target='_blank' href='https://www.instagram.com/code_with_ssk'>Send a DM in instagram - Code with SSK</a>
        <p>or you can send email to <span style={{ color: 'blue' }}>hey@instantdm.com</span></p>
        {/* <TextArea value={feedbacktext} onChange={(e) => setFeedbackText(e.target.value)} rows={8} placeholder="Please share your feedback here." /> */}

      </Modal>

      <Modal
        title="Automation not working?"
        open={showReconnect}
        confirmLoading={confirmLoading}
        onCancel={() => { setShowReconnect(false) }}
      >

        <div className='Connected Accounts'>

          {settingsPayload?.connected_accounts?.fb_data?.error && <Alert
            message="Facebook conection expired"
            showIcon
            description="Reconnect your facebook page to use the automation features."
            type="error"
            action={
              <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
            }
          />}

          {settingsPayload?.connected_accounts?.ig_data?.error && <Alert
            message="Instagram conection expired"
            showIcon
            description="Reconnect your Instagram account to use."
            type="error"
            action={
              <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
            }
          />}

        </div>

        <Divider />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '40px' }}>
          <a href="/ig-connect?show_ig_connect=true"><Button danger>Connect Instagram Directly</Button></a>
          <a href="/ig-connect"><Button danger>Connect Instagram via FB Page</Button></a>
          <Divider />
        </div>

        <Collapse items={[
          {
            key: '1',
            label: 'More options!',
            children:
              <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', gap: '20px', marginBottom: '40px' }}>
                <h3>Please Select your issue</h3>
                <Button danger><a href="/ig-connect">Reels, Posts Comment DM not working?</a></Button>
                <Button danger><a href="/ig-connect?show_ig_connect=true">Story DM not working?</a></Button>
                <Button danger><a href="/ig-connect?show_ig_connect=true">Followers only DM not working?</a></Button>
              </div>
          }]} />
        <Divider />


        {/* <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            Regular post comment automation not working
            <Button type="primary" danger><a href="/ig-connect">Reconnect Instagram via FB</a></Button>
          </div>
          <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            <p>Boosted post comment automation not working</p>
            <Button danger><a href="/ig-connect?show_ig_connect=true">Reconnect with Instagram</a></Button>
          </div> */}

        <Collapse items={[
          {
            key: '1',
            label: 'Not working after reconnected?',
            children: <p>Please reach out via instagram <a href='https://instagram.com/code_with_ssk' target='_blank'>@code_with_ssk</a> or mail us at hey@instantdm.com</p>,
          },


        ]} />
      </Modal>

      {/* Pending Collab Invite Modal */}
      <Modal
        title="Pending Invitation"
        open={inviteModalOpen}
        onCancel={() => setInviteModalOpen(false)}
        footer={[
          <Button key="decline" onClick={handleDeclineInvite}>
            Ignore
          </Button>,
          <Button key="approve" type="primary" loading={inviteProcessing} onClick={handleApproveInvite}>
            Review Request
          </Button>,
        ]}
      >
        {inviteLoading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <Spin tip="Loading invite details..." />
          </div>
        ) : (
          inviteData && (
            <div style={{ textAlign: "center" }}>
              {inviteData.sender?.picture && (
                <img
                  src={inviteData.sender?.picture}
                  style={{ width: 60, height: 60, borderRadius: "50%", marginBottom: 10 }}
                  alt="Sender"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              )}
              <h3>@{inviteData.sender?.username} x @{inviteData.post?.username}</h3>
              <p>to automate a collab post on InstantDM.</p>

              <div style={{ background: "#f5f5f5", padding: 10, borderRadius: 8, marginTop: 15, display: "flex", gap: 10, alignItems: "center" }}>
                <img
                  src={inviteData.post?.image}
                  style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
                  alt="Post"
                />
                <div style={{ textAlign: "left", overflow: "hidden" }}>
                  <p style={{ margin: 0, fontWeight: "bold" }}>@{inviteData.post?.username}</p>
                  <p style={{
                    margin: 0,
                    fontSize: 12,
                    color: "#666",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 250
                  }}>
                    {inviteData.post?.caption || "No caption"}
                  </p>
                </div>
              </div>
            </div>
          )
        )}
      </Modal>

      <Modal
        closable={false}
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Settings</span>
            <div style={{ display: "flex", gap: '10px' }}>
              <Button onClick={() => { setSettingsPayload(initialSettingPayload); setShowSettings(false); }}>Cancel</Button>
              <Button type="primary" loading={updateLoading} onClick={updateSettingsAPI}>
                Save Settings
              </Button>
            </div>
          </div>
        }
        open={showSettings}
        footer={null} // Hide default footer
      >
        {settingsPayload?.automation_setting != undefined &&
          <>
            <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>Instagram Saftey Settings</h3>
            <p style={{ marginTop: '0px', fontSize: '12px' }}>Configure your Instagram account saftey settings.</p>



            <div className='setting-item'>
              <div className='row'>
                <h3> Facebook Page <Tag color={settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "green" : "red"}>{settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "Connected" : "Not Connected"}</Tag></h3>
                <Button href="/ig-connect"  >
                  {settingsPayload?.connected_accounts?.fb_data?.id != undefined ? "Re-Connect FB Page" : "Connect FB Page"}
                </Button>
              </div>
              <p>Connect Facebook page for better comment delivery ratio and advanced account saftey. InstantDM will distribute automation between your IG account and FB Page. This will keep your account under radar from instagram automation detection.</p>

            </div>


            <div className='setting-item'>


              <div className='row'>
                <h3>New Automation Per Hour</h3>

                <Select
                  style={{ width: "170px" }}
                  onChange={(value) => updateAutomationData('plan_rate_limit', value)}
                  defaultValue={defaultAutomation}
                  options={filteredOptions}
                />

              </div>
              <p>No.of new comment to DM automation per hour.</p>
            </div>

            <div className='setting-item'>
              <div className='row'>
                <h3>Rate Limit Retry</h3>
                <Slider
                  min={1}
                  max={120}
                  defaultValue={settingsPayload.automation_setting.rate_limit_retry || 60}
                  onChange={(value) => { updateAutomationData('rate_limit_retry', value) }}
                  style={{ width: '150px' }}
                  tooltip={{
                    formatter: (value) => SliderFormat(value)
                  }}
                />
              </div>
              <p>Retry duration after you have reached instagram rate limit. Recommended to keep 30 - 60 minutes for maximum account saftey.</p>
              <p>Currently set to {SliderFormat(settingsPayload.automation_setting.rate_limit_retry || 60)}</p>
            </div>

            <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>Account Automation settings</h3>
            <p style={{ marginTop: '0px', fontSize: '12px' }}>Configure your account level automation</p>
            <div className='setting-item'>

              <div className='row'>
                <h3 >Global Automations</h3>
                <Radio.Group onChange={(e) => updateAutomationData('account_automation', e.target.value)} defaultValue={settingsPayload.automation_setting.account_automation}>
                  <Radio.Button value="true">Enabled</Radio.Button>
                  <Radio.Button value="false">Disabled</Radio.Button>
                </Radio.Group>
              </div>
              <p>Your account level automation, if you disabled it no automations will work.</p>
            </div>
            <div className='setting-item'>
              <div className='row'>
                <h3>Comment Replies</h3>
                <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                  <Radio.Group onChange={(e) => updateAutomationData('comment_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.comment_automation}>
                    <Radio.Button value="true">Enabled</Radio.Button>
                    <Radio.Button value="false">Disabled</Radio.Button>
                  </Radio.Group>
                </Tooltip>
              </div>
              <p>Your account level comment automation, if you disabled it no comment automations will work.</p>
            </div>
            <div className='setting-item'>
              <div className='row'>
                <h3>DM Automations</h3>
                <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                  <Radio.Group onChange={(e) => updateAutomationData('dm_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.dm_automation}>
                    <Radio.Button value="true">Enabled</Radio.Button>
                    <Radio.Button value="false">Disabled</Radio.Button>
                  </Radio.Group>
                </Tooltip>
              </div>
              <p>Your account level DM automation, if you disabled it no DM automations will work.</p>
            </div>

            <div className='setting-item'>
              <h3>Account Setting</h3>
              <p>{settingsPayload.token_data.emailid}</p>
            </div>

            {/* <div className='setting-item'>
                <div className='row'>
                  <h3>Trending Mode - Cool Off</h3>
                  <Tooltip title={"Cool off period for your account before activating viral mode."}>
                    
                  <Slider
                    min={5}
                    max={180}
                    step={5}
                    defaultValue={settingsPayload.automation_setting.treding_cool_off_waiting || 60}
                    onChange={(value) => {updateAutomationData('treding_cool_off_waiting', value)}}
                    style={{width:'150px'}}
                    tooltip={{SliderFormat}}
                  />

                  </Tooltip>
                </div>
                <p>Cool-Off period is set to {settingsPayload.automation_setting.treding_cool_off_waiting || 60 } Minutes.</p>
              </div> */}




          </>
        }

        <p>To cancel subscription please contact via email: subscriptions@instantdm.com </p>
        <Button danger onClick={handleLogout}>Logout</Button>
      </Modal>

      <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => {
          setShowPlanModal(false);
          if (props?.setShowPlan != undefined) {
            props.setShowPlan(false)
          }
        }}
        footer={null}
        style={{ top: 0, overflowX: "scroll" }}
        width='100%'
        height={"100hh"}
      // style={{ maxWidth: '1200px' }}
      >

        <ShowPlans messageApi={messageApi} userPlan={userPlan} userUsage={userUsage} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
      </Modal>


      <Modal
        title="Teams & Users"
        open={showTeams}
        width={"80%"}
        style={{ maxWidth: "1000px", minWidth: "600px" }}
        footer={[
          <Button key="cancel" onClick={() => setShowTeams(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => { }}>
            Save changes
          </Button>
        ]}
      >

        <UserRoleManager />
      </Modal>
      {/* <Modal
          title="Create new client account!"
          open={showCreateAccount}
          width={800}
          height={600}
          onOk={() => {
            setShowCreateAccount(false)
          }}
          onCancel={() => { setShowCreateAccount(false) }}
        >

          

        </Modal> */}

      <Modal closable={false}
        style={{ top: "0" }}
        width={"100%"}
        footer={[]}
        // style={{marginTop:"-20px"}}

        //    footer={  [
        //   currentAutomateStep > 0 && <Button
        //   key="back"
        //   onClick={() => setCurrentAutomateStep(currentAutomateStep - 1)}
        //   disabled={currentAutomateStep === 0}
        //   style={{ marginRight: 8 }}
        // >
        //   Previous
        // </Button> ,
        // currentAutomateStep < 2 ? (
        //   <Button
        //     key="next"
        //     type="primary"
        //     onClick={() => setCurrentAutomateStep(currentAutomateStep + 1)}
        //     // disabled={
        //     //   (currentAutomateStep === 0 )
        //     // }
        //   >
        //     {currentAutomateStep === 1 ?  "Close Demo" : "Next Check DM Automation"}
        //   </Button>
        // ) : (
        //   <Button
        //     key="submit"
        //     type="primary"
        //     loading={false}
        //     disabled={true}
        //     onClick={() => {

        //     }}
        //   >
        //     Create Account
        //   </Button>
        // ),
        //     ]}

        // bodyStyle={{ background: "#f7f8fa" }} 
        open={currentAutomateStep > -1}
        title={""}>
        {
          currentAutomateStep === 0 && <TestCommentAutomation setCurrentAutomateStep={setCurrentAutomateStep} username={decodedToken?.username} link={igPosts?.[0]?.permalink} image_url={igPosts?.[0]?.thumbnail_url || igPosts?.[0]?.media_url} />
        }
        {
          currentAutomateStep === 1 && <TestDMAutomation setCurrentAutomateStep={setCurrentAutomateStep} username={decodedToken?.username} pp={decodedToken?.profile_picture_url} name={decodedToken?.name} />
        }

        {
          currentAutomateStep === 2 && <ConnectFBUI setCurrentAutomateStep={setCurrentAutomateStep} username={decodedToken?.username} pp={decodedToken?.profile_picture_url} name={decodedToken?.name} />
        }

      </Modal>


      {/* <Modal closable={false} 
    style={{top:"0"}}
    width={"100%"}
    height={"100vh"}
    bodyStyle={{ background: "#f7f8fa" }} 
    footer = {[]} 
    open={true}
    >
  <AccountCreationSteps/>
</Modal> */}


      <Modal
        closable={false}
        className="onboarding-modal"
        footer={!emailIDUpdateData?.activated && [
          currentStep > 0 && currentStep < onboardingSteps.length - 1 && <Button
            key="back"
            onClick={() => setCurrentStep(currentStep - 1)}
            disabled={currentStep === 0}
            className="onboarding-back-btn"
            icon={<LeftOutlined />}
          />,
          // Hide footer buttons on email step (last step) - OTP controls are in the step content
          currentStep < onboardingSteps.length - 1 && (
            <Button
              key="next"
              type="primary"
              className="onboarding-conitnue-btn"
              onClick={() => setCurrentStep(currentStep + 1)}
              disabled={
                (currentStep === 0 && !onboardingData.step1) ||
                (currentStep === 1 && !onboardingData.step2) ||
                (currentStep === 2 && !onboardingData.step3) ||
                (currentStep === 3 && !onboardingData.step4)
                // Website (step 4) and WhatsApp (step 5) are optional/skippable
              }
            // className="onboarding-btn-primary"
            >
              {(currentStep === 4 && !onboardingData.step5) || (currentStep === 5 && !whatsappNumber) ? "Skip →" : currentStep == -1 ? "Let's Go!" : "Continue →"}
            </Button>
          ),
          // Back button only on email step (step 6)
          currentStep === onboardingSteps.length - 1 && otpStep === 'email' && (
            <Button
              key="back-email"
              onClick={() => setCurrentStep(currentStep - 1)}
              className="onboarding-back-btn"
              icon={<LeftOutlined />}
            />
          ),
        ]}
        open={settingsPayload?.not_activated && currentAutomateStep < 0 && firstAutomationCompleted}
        title={null}
        width={400}
      >
        {/* Welcome Screen */}
        {currentStep == -1 && (
          <div className="onboarding-welcome">
            {/* Profile Section - Instagram Style */}
            <div className="onboarding-profile">
              <div className="onboarding-avatar-wrapper">
                <img
                  src={decodedToken?.profile_picture_url || '/logo192.png'}
                  alt="Profile"
                  className="onboarding-avatar-img"
                />
                <div className="onboarding-verified-icon">
                  <CheckCircleFilled style={{ color: '#1DA1F2', fontSize: 16 }} />
                </div>
              </div>
              <h2 className="onboarding-profile-username">@{decodedToken?.username || "username"}</h2>
              <div className="onboarding-connected-badge">
                <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 14 }} />
                <span>Instagram Connected</span>
              </div>
            </div>

            {/* Welcome Text */}
            <div className="onboarding-welcome-text">
              <h3>Welcome to InstantDM! 👋</h3>
              <p>Let's set up your automation in 2 minutes</p>
            </div>

            {/* Quick Features */}
            <div className="onboarding-quick-features">
              <div className="onboarding-quick-feature">
                <ThunderboltFilled style={{ color: '#722ED1' }} />
                <span>Comment to DM</span>
              </div>
              <div className="onboarding-quick-feature">
                <MessageOutlined style={{ color: '#1890FF' }} />
                <span>Smart Flows</span>
              </div>
              <div className="onboarding-quick-feature">
                <SafetyCertificateFilled style={{ color: '#52C41A' }} />
                <span>Meta Verified</span>
              </div>
            </div>
          </div>
        )}

        {/* Steps Content */}
        {(currentStep > -1 && !emailIDUpdateData?.activated) && (
          <div className="onboarding-steps-container">
            {/* Progress Bar */}
            <div className="onboarding-progress">
              <div className="onboarding-progress-bar">
                <div
                  className="onboarding-progress-fill"
                  style={{ width: `${((currentStep + 1) / onboardingSteps.length) * 100}%` }}
                />
              </div>
              {/* <span className="onboarding-progress-text">
                Step {currentStep + 1} of {onboardingSteps.length}
              </span> */}
            </div>

            {/* Step Content */}
            <div className="onboarding-step-content">
              {onboardingSteps[currentStep].content}
            </div>
          </div>
        )}

        {/* Account Creation Animation */}
        {emailIDUpdateData?.activated && <AccountCreationSteps
          setCurrentAutomateStep={setCurrentAutomateStep}
          onComplete={() => setShowOnboardingPricing(true)}
        />}

      </Modal>


      {/* First Automation Onboarding - Aha Moment - DISABLED */}
      <FirstAutomationOnboarding
        open={false}
        onClose={() => {
          localStorage.setItem('firstAutomationCompleted', 'true');
          setFirstAutomationCompleted(true);
        }}
        onComplete={() => {
          localStorage.setItem('firstAutomationCompleted', 'true');
          setFirstAutomationCompleted(true);
        }}
        onSetupAccount={() => {
          // Trigger the regular onboarding flow
          setCurrentStep(0);
        }}
        decodedToken={decodedToken}
      />

      {/* Onboarding Pricing Popup */}
      <OnboardingPricingModal
        open={showOnboardingPricing}
        onClose={() => setShowOnboardingPricing(false)}
        messageApi={messageApi}
        setPaymentLinkLoading={setPaymentLinkLoading}
        setPaymentLinkData={setPaymentLinkData}
      />

      <LegendProOfferModal open={userPlan?.data?.claim_free_one_month} isConnectionExpired={settingsPayload?.connected_accounts?.ig_data?.error} />


      <Drawer title="Hey, whatsup?" width={"90%"} open={showMenuDrawer} onClose={() => setShowMenuDrawerMobile(false)}>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          // inlineCollapsed={collapsed}
          style={{ border: 'none', marginTop: '16px', background: collapsed ? "transparent" : "white" }}
          items={menuItems.map(item => ({
            ...item,
            label: item?.path ? <Link to={item?.path}>{item.label}</Link> : item?.label,
            icon: item?.path ? <Link to={item?.path}>{item.icon}</Link> : item?.icon,
            onClick: item.onClick || (() => { })
          }))}
        />
        <div style={{
          display: 'flex',
          flexDirection: 'column', padding: '16px', height: "300px", borderTop: '1px solid #f0f0f0'
        }}>
          <div
            onClick={() => { setShowReconnect(true) }}
            style={{
              cursor: 'pointer',
              padding: '12px',
              borderRadius: '8px',
              background: '#fff2e8',
              border: '1px solid #ffbb96',
              marginBottom: '16px',

            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: '#ff4d4f',
                fontSize: '14px',
                fontWeight: 500
              }}>
              <ExclamationCircleOutlined /> Automation Not working?
            </div>
          </div>
          {/* <p>Hello</p> */}
          <SwitchAccountPopover returnAvatarOnly={false} />

        </div>
      </Drawer>
    </div >)

}
export default Sider;